export const GET_SEA_PORTS = "GET_SEA_PORTS";
export const GET_SEA_PORT = "GET_SEA_PORT";
export const ADD_SEA_PORT = "ADD_SEA_PORT";
export const DELETE_SEA_PORT = "DELETE_SEA_PORT";
export const UPDATE_SEA_PORT = "UPDATE_SEA_PORT";
